// Common name fragments shipped by virtual audio loopback drivers. These
// devices appear in getUserMedia enumeration but produce silence as a
// capture source — they're designed to route system audio OUTPUT into
// recording apps, not capture mic INPUT. Match is case-insensitive and
// uses includes() against the device label.
//
// Intentionally NOT included:
//   - "krisp" — Krisp is a noise-cancellation pipeline that genuinely
//     records the user's voice (with filtering). Users intentionally pick
//     "Krisp Microphone" to remove background noise. Flagging it would
//     wrongly warn legitimate users.
//   - "aggregate"/"multi-output" — macOS aggregate devices can legitimately
//     combine real mics (e.g. stereo pair). Without label parsing of the
//     constituent devices we can't tell apart.
const VIRTUAL_AUDIO_DEVICE_KEYWORDS = [
    "loom",            // LoomAudioDevice — screen recording
    "blackhole",       // BlackHole 2ch/16ch — macOS open-source loopback
    "soundflower",     // Legacy macOS loopback (still widely installed)
    "obs virtual",     // OBS Virtual Audio (scoped — "obs" alone is too broad)
    "ishowu",          // iShowU Audio Capture — macOS
    "vb-audio",        // VB-Audio brand (Hi-Fi Cable, etc.)
    "vb-cable",        // VB-Audio Virtual Cable — Windows
    "vb cable",        // Space-separated label variant
    "virtual",         // Generic catch-all for "* Virtual Audio/Cable/Mic"
    "loopback",        // Rogue Amoeba Loopback app
    "voicemeeter",     // VB-Audio VoiceMeeter — Windows mixer
    "wavtap",          // Legacy macOS loopback (rare but seen)
] as const;

export function isVirtualAudioDevice(label?: string | null): boolean {
    if (!label) return false;
    const lower = label.toLowerCase();
    return VIRTUAL_AUDIO_DEVICE_KEYWORDS.some((kw) => lower.includes(kw));
}
